export default "__VITE_ASSET__DT7S6Yqs__"